export enum EmployeeType {
    Shipper = 1,
    Teller = 2
}